"use client";

import CommonImage from "@/components/common/image/CommonImage";
import Drawer from 'antd/es/drawer';
import Link from "next/link";
import { usePathname } from "next/navigation";
import React from "react";
import { FaSearch } from "react-icons/fa"; 
import SearchBarMobile from "../search/SearchBarMobile";
import { useSelector } from "react-redux";

export default function MobileMenuDrawer({
  menuItems,
  isMenuOpen,
  setIsMenuOpen,
}) {
  const pathname = usePathname();
  const setting = useSelector((state) => state.setting.data);

  // console.log("menuItems",menuItems)
  return (
    <Drawer
      open={isMenuOpen}
      onClose={() => setIsMenuOpen(false)}
      placement="right"
      height="auto"
      maskClosable
      destroyOnClose
      styles={{
        header: { display: "none" },
      }}
      closable={false}
      className="mobile-sidebar"
    >
      {/* Drawer Header */}
      <div className="bar-header">
        <a herf="#" className="img-wrap leading-0">
          <CommonImage
            src={
                setting?.logo_light_url ??
                "/images/header-footer/main_logo_light.avif"
              }
            alt="Icon"
            className="icon-img [.dark_&]:hidden inline-block" 
          />
          <CommonImage
            src={
                setting?.logo_dark_url ??
                "/images/header-footer/main_logo_light.avif"
              }
            alt="Icon"
            className="icon-img hidden [.dark_&]:inline-block" 
          />
        </a>
        <button onClick={() => setIsMenuOpen(false)} className="close-icon">
          ✕
        </button>
      </div>

      {/* Drawer Content */}
      <div className="sidebar-content">
        <div className="header-part-wrap">
          <SearchBarMobile />
          {menuItems.map((item) => (
            <Link
              key={item.key}
              href={item.href}
              className="nav-link"
              onClick={() => setIsMenuOpen(false)}
            >
              <div className="flex items-center gap-3">
                <div className="img-wrap leading-0">
                  <CommonImage
                    src={item.icon}
                    alt="Icon"
                    className="icon-img w-4 h-4 hidden [.dark_&]:bg-block"
                  />
                  <CommonImage
                    src={"/images/admission-icon-dark/d-computer.avif"}
                    alt="Icon"
                    className="icon-img w-4 h-4 block [.dark_&]:bg-hidden"
                  />
                </div>
                {item.label}
              </div>
            </Link>
          ))}

          <a
            href="https://www.focusonlinebd.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            <div className="flex items-center gap-3">
              <div className="img-wrap leading-0">
                <CommonImage
                  src={"/images/admission-icon-dark/d-computer.avif"}
                  alt="Icon"
                  className="icon-img w-4 h-4 block [.dark_&]:bg-hidden"
                />
              </div>
              এডমিশন প্রোগ্রাম
            </div>
          </a>
        </div>
      </div>
    </Drawer>
  );
}
